import React, { useEffect } from 'react';
import { Drawer, Menu } from 'antd';
import { Link as NavLink, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import Logo from './Logo';
import ProfileMenu from './ProfileMenu';
import { featureFlag } from '../../constant';
import { MarkIcon } from '../icons';
import { consoleMenuMobile } from '../sidebar/constant';

const { SubMenu } = Menu;

const MobileMenu = (props) => {
  const {
    visible,
    selectedKey,
    onClose,
    handleSignOut,
    onClickSignIn,
    onAboutGlosClick,
    onSeagullCoastClick,
  } = props;

  const history = useHistory();

  useEffect(() => {
    history.listen(() => {
      if (visible) {
        onClose();
      }
    });
  }, [history]);

  const menuItems = [
    {
      key: 'map',
      title: 'Map',
    },
    ...consoleMenuMobile,
    {
      key: 'about',
      title: 'About',
      children: [
        {
          key: 'about-glos',
          title: 'About GLOS',
          action: 'modal',
        },
        {
          key: 'seagull-coast',
          title: 'Seagull Coast',
          action: 'modal',
        },
        {
          key: 'support-seagull',
          title: 'Support GLOS',
        },
        {
          key: 'legal',
          title: 'Legal',
          href: 'https://glos.org/legal/',
        },
        {
          key: 'privacy-policy',
          title: 'Privacy Policy',
          href: 'https://glos.org/privacy-policy/',
        },
      ],
    },
  ];

  return (
    <Drawer
      className="mobile-nav"
      width="100%"
      onClose={onClose}
      open={visible}
      closable
      placement="left"
      zIndex={1002}
      title={<Logo onNavigate={onClose} />}
    >
      <Menu
        defaultSelectedKeys={[selectedKey]}
        defaultOpenKeys={[consoleMenuMobile[0].key, 'about']}
        className="top-menu"
        onClick={onClose}
        mode="inline"
        style={{
          marginBottom: 40,
          paddingBottom: 40,
        }}
      >
        <Menu.Item
          key="seagull-mark"
          style={{
            height: 60,
            marginTop: 20,
            marginLeft: -5,
            marginBottom: 20,
          }}
        >
          <MarkIcon />
        </Menu.Item>
        {menuItems.map((menuItem) => (
          menuItem?.children
            ? (
              <SubMenu
                className="h2"
                key={menuItem?.key}
                title={`${menuItem?.title}`}
              >
                {menuItem?.children && menuItem?.children?.map((subMenuItem) => (
                  <Menu.Item key={subMenuItem?.key}>
                    {subMenuItem?.action === 'modal' ? (
                      <a onClick={subMenuItem.key === 'seagull-coast' ? onSeagullCoastClick : onAboutGlosClick}>
                        <span>{subMenuItem.title}</span>
                      </a>
                    ) : subMenuItem?.href ? (
                      <a href={subMenuItem.href}>
                        <span>{subMenuItem.title}</span>
                      </a>
                    ) : subMenuItem.key === '/data-console' ? (
                      <a
                        onClick={() => history.push(
                          sessionStorage.getItem('lastConsoleUrl') || '/data-console',
                        )}
                      >
                        <span>{subMenuItem?.title}</span>
                      </a>
                    ) : (
                      <NavLink to={subMenuItem.key}>
                        <span>{subMenuItem?.title}</span>
                      </NavLink>
                    )}
                  </Menu.Item>
                ))}
              </SubMenu>
            ) : (
              <Menu.Item className="h2" key={menuItem.key}>
                {menuItem.key === 'map' ? (
                  <a onClick={() => history.push(sessionStorage.getItem('lastMapUrl') || '/map')}>
                    <span>{menuItem.title}</span>
                  </a>
                ) : (
                  <NavLink to={`/${menuItem.key}`}>
                    <span>{menuItem.title}</span>
                  </NavLink>
                )}
              </Menu.Item>
            )
        ))}
      </Menu>
      {featureFlag.userProfile && (
        <ProfileMenu isMobile handleSignOut={handleSignOut} onClickSignIn={onClickSignIn} onMenuClick={onClose} />
      )}
    </Drawer>
  );
};

MobileMenu.propTypes = {
  selectedKey: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  handleSignOut: PropTypes.func,
  onClickSignIn: PropTypes.func,
  onAboutGlosClick: PropTypes.func,
  onSeagullCoastClick: PropTypes.func,
};

MobileMenu.defaultProps = {
  selectedKey: '',
  visible: false,
  onClose: () => {},
  handleSignOut: () => {},
  onClickSignIn: () => {},
  onAboutGlosClick: () => {},
  onSeagullCoastClick: () => {},
};

export default MobileMenu;
